import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  gap: 1.5rem;
  flex-direction: column;

  @media (max-width: 350px) {
    gap: 0.6rem;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  .headerTitle {
    display: flex;
    flex-direction: row;
    align-items: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    svg {
      padding: 0 0.5rem 0 0;
      color: ${({ theme }) => theme.colors.tertiary_500};
      fill: ${({ theme }) => theme.colors.tertiary_500};
    }

    h1 {
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 1.5rem;
      color: ${({ theme }) => theme.colors.tertiary_500};
    }
  }

  .headerInput {
    .text-field {
      width: 15rem;

      .MuiFormLabel-root {
        top: -14px;
      }

      .MuiInputBase-root {
        margin-top: 0 !important;
      }
    }
  }

  @media (max-width: 500px) {
    flex-direction: column;

    .headerTitle {
      width: 100%;
    }

    .headerInput {
      width: 100%;
      text-align: end;
    }
  }

  @media (max-width: 350px) {
    .headerInput .text-field {
      width: 100%;
    }
  }
`;

export const Content = styled.div`
  .container-collaborators {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    height: 100%;
    max-height: 15rem;
    overflow-y: auto;

    .card {
      display: flex;
      flex-direction: column;
      border-radius: 1rem;
      box-shadow: 1px 2px 6px rgb(0 0 0 / 20%);
      padding: 0.5rem;
      max-width: 15rem;
      margin: 0 1rem 0.5rem 0.1rem;

      .card-header {
        max-width: 12.5rem;
        display: flex;
        align-items: center;
        padding: 0.2rem 0;

        h1 {
          font-size: 1rem;
          font-weight: 300;
          color: ${({ theme }) => theme.colors.text};
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        svg {
          min-width: 1.2rem;
          max-width: 1.2rem;
          min-height: 1.2rem;
          max-height: 1.2rem;
          margin-right: 0.2rem;
          fill: ${({ theme }) => theme.colors.primary};
        }
      }

      .card-body {
        display: flex;
        padding: 0.2rem 0;

        p {
          font-size: 1rem;
          color: ${({ theme }) => theme.colors.text_gray};
          font-weight: 300;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }

  .container {
    width: 100%;
    display: flex;
    justify-content: center;

    h1 {
      font-size: 1.5rem;
      color: ${({ theme }) => theme.colors.secondary};
    }
  }

  @media (max-width: 520px) {
    .container-collaborators {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  @media (max-width: 350px) {
    .container-collaborators {
      grid-template-columns: repeat(1, 1fr);

      .card {
        width: 92% !important;
        min-width: 92% !important;
        margin: 0.3rem;
      }
    }
  }
`;
